/**
 * Created by fers on 26.09.15.
 */

import { declareLinkedEntity } from '../fw/MetaDataHelper.ts';
import {STATUS_WAITING, StatusType} from './JobType';
import { v4 as uuidv4 } from 'uuid';

export default declareLinkedEntity({
    entity: 'jobTasks',
    graphQL: "JobTask",
    name: "Job Tasks",
    storageType: 'central',
    userEditable: false,
    parentRelation: "jobTasks",
    defaultOrder: ['order'],
    fields: (types) => {
        return {
            id: {
                name: "Task ID",
                type: "string",
                primaryKey: true,
                defaultValue: () => {
                    return uuidv4();
                },
            },
            type: {
                name: "Type",
                type: "string",
                defaultValue: "",
            },
            typeName: {
                name: "Type Name",
                type: "enum",
                values: {
                    "auth": {
                        name: "Authentication check"
                    },
                    "transformer": {
                        name: "Final data transforming"
                    },
                    "generate": {
                        name: "Generate"
                    },
                }
            },
            name: {
                name: "Name",
                type: "string",
                defaultValue: "",
                translatable: true,
            },
            order: {
                name: "Order",
                type: "int",
            },
            job: {
                name: "Job",
                type: "relation",
                to: () => types['jobs'],
                defaultValue: (job) => {
                    return job['id'];
                },
                required: true,
                parent: true,
                hiddenCreate: true,
                compositeKey: true,
            },
            status: {
                name: "Status",
                type: "enum",
                defaultValue: STATUS_WAITING,
                values: StatusType
            },
            message: {
                name: "Message",
                type: "string",
                defaultValue: null,
            },
            errorStack: {
                name: "Error stack",
                type: "text",
            },
            stage: {
                name: "Stage",
                type: "string",
                defaultValue: null,
            },
            progress: {
                name: "Progress",
                type: "object",
                defaultValue: {},
                userEditable: false,
            },
        };
    }
});
